module.exports = __webpack_public_path__ + "img/AppGallery_Button.d183397b.svg";